<template>
  <span
    :class="mergedClasses"
    v-bind="passthroughAttrs"
  >
    <slot />
  </span>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HdBadge',

  inheritAttrs: false,

  props: {
    variant: {
      type: String,
      default: 'secondary'
    },
    pill: {
      type: Boolean,
      default: false
    }
  },

  emits: [],

  computed: {
    badgeClasses() {
      const classes = ['badge', `badge-${this.variant}`];

      if (this.pill) classes.push('badge-pill');

      return classes;
    },

    mergedClasses() {
      return [this.$attrs.class, this.badgeClasses].flat().filter(Boolean);
    },

    passthroughAttrs() {
      const { class: _class, ...attrs } = this.$attrs;

      return attrs;
    }
  }
});
</script>
